import {t} from '@lingui/core/macro';

import {IColumn} from 'shared/ui/Table/Table';

import IServerIncident from '../model/ServerIncident/IServerIncident';

export function getServerIncidentColumns(hideServer: boolean): IColumn[] {
    return [
        {label: t`Статус`},
        ...(hideServer ? [] : [{label: t`Сервер`, sort: 'server.name'}]),
        {label: t`Метрика`, sort: 'metric'},
        {label: t`Условие`},
        {label: t`Важность`, sort: 'severity'},
        {label: t`Открыт`, sort: 'opened_at'},
        {label: t`Закрыт`, sort: 'closed_at'},
        {label: t`Длительность`},
        {label: ''},
    ];
}

export function isServerIncidentOpen(incident: IServerIncident): boolean {
    return incident.closed_at === null;
}

export function isServerHeartbeatIncident(incident: IServerIncident): boolean {
    return incident.type === 'heartbeat';
}

export function getServerIncidentThreshold(incident: IServerIncident): string {
    if (isServerHeartbeatIncident(incident)) {
        return t`отсутствует 10 минут`;
    }

    if (incident.operator === null || incident.threshold === null) {
        return '—';
    }

    return `${incident.operator} ${incident.threshold}`;
}

export function getServerIncidentStatusLabel(isOpen: boolean): string {
    return isOpen ? t`Открыт` : t`Закрыт`;
}

export function getServerIncidentDurationSeconds(incident: IServerIncident): number {
    const openedAt = new Date(incident.opened_at).getTime();
    const endAt = incident.closed_at ? new Date(incident.closed_at).getTime() : Date.now();

    return Math.max(0, Math.floor((endAt - openedAt) / 1000));
}
